import React from "react";
import { ReactComponent as Logo } from "../../../images/valoo-logo.svg";
import AccountMenu from "./menu/AccountMenu";
import styles from "./Header.module.css";
import Assistant from "./assistant/Assistant";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
import { useSubscribeSocket } from "hooks/useSocket";

function Header({ isOutDated, inProgress, startSurvey = () => {} }) {
  // == Is Mobile - START ==
  useSubscribeSocket();
  const isMobile = useIsMobile();
  // == Is Mobile - END ==

  return (
    <>
      {isMobile ? (
        // Mobile version
        <>
          <div className="separatorEmptyMedium"></div>
          <header className={`${styles.container}`}>
            <div className={styles.logoContainer}>
              <Logo alt="Valoo Logo" className={styles.logo} />
            </div>
            <div>
              <Assistant />
            </div>
            <AccountMenu />
          </header>
          <div className="separatorEmptyMedium"></div>
        </>
      ) : (
        // Desktop version
        <>
          <header className={`${styles.container} maxWidth marginAuto`}>
            <div className={styles.logoContainer}>
              <Logo alt="Valoo Logo" className={styles.logo} />
            </div>
            <div>
              <Assistant />
            </div>
            <AccountMenu />
          </header>
        </>
      )}
      {isOutDated ||
        (inProgress && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: 2,
              maxWidth: "md",
              mx: "auto",
            }}
          >
            <Alert severity="warning">
              <AlertTitle>Important Update</AlertTitle>
              Heads up! The survey you completed has been updated. Please
              consider updating your response to help us with the latest
              information.
              <Box
                sx={{
                  textAlign: "right",
                  mt: 1,
                }}
              >
                <Button
                  onClick={() => {
                    startSurvey();
                  }}
                  color="warning"
                  size="small"
                  variant="outlined"
                >
                  Update Response
                </Button>
              </Box>
            </Alert>
          </Box>
        ))}
    </>
  );
}

export default Header;
